import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "24.187",
      cy: "9.004",
      fill: "#0A1121",
      rx: "3.1",
      ry: "4"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "9.787",
      cy: "9.004",
      fill: "#0A1121",
      rx: "3.1",
      ry: "4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#37454D",
      d: "M7.287 28.704c2-.7 5-1.7 9.7-1.7v-2.7c-6.1.1-8.4 1.4-10.8 2.3-1.3.5-2.3 3.3 1.1 2.1m20.5-2.1c-2.4-1-4.7-2.2-10.8-2.3v2.7c4.7 0 7.7 1 9.7 1.7 3.4 1.2 2.4-1.6 1.1-2.1"
    }, null, -1)
  ]))]))
}
export default { render: render }